var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { ActionBuilder, FieldArg, StateArg, } from '../layout-actions';
import { MessageService } from '@synisys/idm-message-language-service-client-js';
import { KbService } from '@synisys/idm-kb-service-client-js';
import { CurrentLanguageProvider } from '@synisys/idm-session-data-provider-api-js';
import { mergeMap } from 'rxjs/operators';
import { LocaleService } from '@synisys/idm-locale-service-client-js';
import { FormattingService } from '@synisys/idm-frontend-shared';
import { of } from 'rxjs/observable/of';
var DynamicFormUtilitiesService = /** @class */ (function () {
    function DynamicFormUtilitiesService(messageService, kbService, currentLanguageProvider, localeService, formattingService) {
        this.messageService = messageService;
        this.kbService = kbService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.localeService = localeService;
        this.formattingService = formattingService;
    }
    DynamicFormUtilitiesService.prototype.formatDate = function (date) {
        if (!date) {
            return '';
        }
        var day = date.getDate();
        var monthId = date.getMonth();
        var year = date.getFullYear();
        var months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];
        return day + ' ' + months[monthId] + ' ' + year;
    };
    DynamicFormUtilitiesService.prototype.formatDateWithTime = function (date) {
        if (!date) {
            return '';
        }
        var months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
        ];
        var day = date.getDate();
        var monthId = date.getMonth();
        var year = date.getFullYear();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return (day +
            ' ' +
            months[monthId] +
            ' ' +
            year +
            ' ' +
            this._toTwoDigit(hour) +
            ':' +
            this._toTwoDigit(minute) +
            ':' +
            this._toTwoDigit(second));
    };
    DynamicFormUtilitiesService.prototype.getImageClass = function (document) {
        var fileName = document.getProperty('DOCUMENTNAME').value;
        var fileExtension = fileName.split('.').pop();
        switch (fileExtension) {
            case 'archive':
                return 'fa fa-file-archive-o fa-3x';
            case 'text':
                return 'fa fa-file-text-o fa-3x';
            case 'excel':
                return 'fa fa-file-excel-o fa-3x';
            case 'word':
                return 'fa fa-file-word-o fa-3x';
            case 'pdf':
                return 'fa fa-file-pdf-o fa-3x';
            case 'jpg':
            case 'png':
            case 'gif':
                return 'fa fa-file-image-o fa-3x';
            case 'ppt':
                return 'fa fa-file-powerpoint-o fa-3x';
            default:
                return 'fa fa-file-o fa-3x';
        }
    };
    DynamicFormUtilitiesService.prototype.changeRadioValue = function (mainEntity, systemName, selectedValue, subEntity) {
        if (subEntity) {
            subEntity.getProperty(systemName).value = selectedValue;
        }
        else {
            mainEntity.getProperty(systemName).value = selectedValue;
        }
    };
    DynamicFormUtilitiesService.prototype.isItemSelected = function (entity, item, systemName) {
        var selectedItemsList = entity.getProperty(systemName).value;
        return selectedItemsList.some(function (selectedItem) {
            return item.getId() === selectedItem.getId();
        });
    };
    DynamicFormUtilitiesService.prototype.getMessage = function (messageKey) {
        return this.messageService.getMessage(messageKey);
    };
    DynamicFormUtilitiesService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('formatDate')
            .params([StateArg('date')])
            .action(this.formatDate)
            .build());
        result.push(new ActionBuilder()
            .name('getMessage')
            .params([StateArg('messageKey')])
            .action(this.getMessage)
            .build());
        result.push(new ActionBuilder()
            .name('getNameMetaFieldIds')
            .params([FieldArg('field-category')])
            .action(function (categorySystemName) {
            return _this.kbService.getNameMetaFieldIds(categorySystemName);
        })
            .build());
        result.push(new ActionBuilder()
            .name('getCurrentLocale')
            .params([])
            .action(function () {
            return _this.currentLanguageProvider
                .getCurrentLanguage()
                .pipe(mergeMap(function (currentLanguage) {
                return _this.localeService.getLocaleInfo(currentLanguage.getId());
            }));
        })
            .build());
        result.push(new ActionBuilder()
            .name('getChooseDatePlaceholder')
            .params([])
            .action(function () { return _this.messageService.getMessage('de.choose_date'); })
            .build());
        result.push(new ActionBuilder()
            .name('sysLocalDate')
            .params([])
            .action(function () { return _this.transformDate.bind(_this); })
            .build());
        return result;
    };
    DynamicFormUtilitiesService.prototype._toTwoDigit = function (digit) {
        return digit < 10 ? '0' + digit : digit.toString();
    };
    DynamicFormUtilitiesService.prototype.transformDate = function (date, format) {
        if (format === void 0) { format = 'date'; }
        switch (format) {
            case 'date':
                return this.formattingService.formatDate(date);
            case 'dateTime':
                return this.formattingService.formatDateTime(date);
            case 'time':
                return this.formattingService.formatTime(date);
        }
        return of('');
    };
    DynamicFormUtilitiesService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [MessageService,
            KbService,
            CurrentLanguageProvider,
            LocaleService,
            FormattingService])
    ], DynamicFormUtilitiesService);
    return DynamicFormUtilitiesService;
}());
export { DynamicFormUtilitiesService };
//# sourceMappingURL=dynamic-form-utilities.service.js.map